import styled from '@emotion/styled';

export const Row = styled('div')(({ alignItems, gap = '12px' }) => ({
  display: 'flex',
  gap: gap,
  alignItems: alignItems,
}));
